import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import styled from 'react-emotion';
import { connect } from 'react-redux';
import { Input } from 'web-ui-components/lib/atoms/forms';
import { TextBody } from 'web-ui-components/lib/atoms/text';
import { Field, FieldBody, FieldHeader, ValidationMessage } from 'web-ui-components/lib/molecules/forms';
import withContent from '../../containers/withContent';
import templateNameContent from './templateName.content';
import { getTemplateName, getIsDuplicate } from '../../states/templates/selectors';
import { updateTemplateName, submitDeleteTemplate } from '../../states/templates/actions';
import withValidation from '../../containers/withValidation';
import { getValidationRowState } from '../../states/validation/selectors';
import { updateValidation, hideErrorMsg } from '../../states/validation/actions';
import { cleanIllegalCharacters } from '../../helpers/fieldHelpers';

const StyledTemplateSection = styled('div')`
	margin-top: 16px;
	margin-bottom: 24px;
	flex: 1;
`;

const mapState = (state) => ({
	name: getTemplateName(state),
	validations: getValidationRowState(state, 'template-name'),
	duplicate: getIsDuplicate(state),
});

const mapDispatch = (dispatch) => ({
	handleChange: (name) => dispatch(updateTemplateName(name)),
	updateValidation: (key, isValid) =>
		dispatch(
			updateValidation({
				id: 'template-name',
				key,
				isValid,
			})
		),
	hideErrorMsg: (key) =>
		dispatch(
			hideErrorMsg({
				id: 'template-name',
				key,
			})
		),
	handleDeleteTemplate: () => dispatch(submitDeleteTemplate),
});

class TemplateName extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			name: props.name,
			hideDuplicateWarning: false,
		};

		this.handleChange = this.handleChange.bind(this);
		this.onBlur = this.onBlur.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		if (this.state.name !== nextProps.name) this.setState({ name: nextProps.name });
		if (nextProps.duplicate) this.setState({ hideDuplicateWarning: false });
	}

	onBlur() {
		if (this.props.name !== this.state.name) this.props.handleChange(this.state.name);
		this.props.onBlur();
	}

	handleChange(event) {
		this.setState({ name: cleanIllegalCharacters(event.target.value), hideDuplicateWarning: true });
	}

	render() {
		const {
			onFocus,
			content: { title, textBody, duplicateWarning },
			errorMessage,
			duplicate,
		} = this.props;

		const hasError = !!errorMessage || (duplicate && !this.state.hideDuplicateWarning);

		return (
			<div>
				<StyledTemplateSection>
					<Field>
						<FieldHeader name="field-template-name-header" titleText={title} />

						<TextBody>{textBody}</TextBody>
						{hasError && (
							<div id="invalid-msg">
								<ValidationMessage value={duplicate ? duplicateWarning : errorMessage} />
							</div>
						)}
						<FieldBody>
							<Input
								type="text"
								className="c-a-input c-a-input--text"
								id="template-name"
								aria-required="true"
								aria-invalid="true"
								value={this.state.name}
								onChange={this.handleChange}
								onFocus={onFocus}
								onBlur={this.onBlur}
								maxLength={30}
							/>
						</FieldBody>
					</Field>
				</StyledTemplateSection>
			</div>
		);
	}
}

TemplateName.propTypes = {
	name: PropTypes.string.isRequired,
	content: PropTypes.shape({
		title: PropTypes.string,
		textBody: PropTypes.string,
	}).isRequired,
	handleChange: PropTypes.func.isRequired,
	onFocus: PropTypes.func.isRequired,
	onBlur: PropTypes.func.isRequired,
	errorMessage: PropTypes.string,
	duplicate: PropTypes.bool,
};

const connectWrapper = connect(mapState, mapDispatch);
const contentWrapper = withContent({ content: templateNameContent });
const validationWrapper = withValidation({
	validations: ['required'],
	key: 'name',
	message: {
		required: 'Please choose a name for this payment template.',
	},
});

export default compose(connectWrapper, validationWrapper, contentWrapper)(TemplateName);
